import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Button from '../../../../components/button';
import { Box, makeStyles, Tooltip, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    minWidth: 174,
    '&:hover': {
      color: 'white'
    }
  },
  icon: {
    marginLeft: '4px',
    '& svg': {
      fontSize: '1rem',
      marginBottom: '-3px'
    }
  }
});

export const ButtonInspection = ({ project }) => {
  const { last_inspected_at, last_inspection_has_formulary, id, last_inspection_id } = project;
  const classes = useStyles();

  return last_inspected_at ? (
    <Button
      component={Link}
      to={
        last_inspection_has_formulary
          ? `/operative/projects/${id}/inspectionspunctual/${last_inspection_id}`
          : `/operative/projects/${id}/inspectionslineal/${last_inspection_id}`
      }
      target="_blank"
      rel="noopener noreferrer"
      variant="contained"
      color="primary"
      className={classes.button}
      fullWidth
    >
      <Typography noWrap>
        <FormattedMessage id="programs.inspection.viewLastInspection" />
      </Typography>
      <Box className={classes.icon}>
        <OpenInNewIcon />
      </Box>
    </Button>
  ) : (
    <Tooltip title={<FormattedMessage id="programs.inspection.noInspections" />} interactive>
      <Button color="primary" disabled variant="contained" fullWidth>
        <Typography noWrap style={{ width: '100%' }}>
          <FormattedMessage id="programs.inspection.viewLastInspection" />
        </Typography>
      </Button>
    </Tooltip>
  );
};

ButtonInspection.propTypes = {
  project: PropTypes.object.isRequired
};
